import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, setBlockTracking as _setBlockTracking, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "card" };
const _hoisted_2 = {
    key: 0,
    class: "px-3 lg:px-4 pt-3 pb-2"
};
const _hoisted_3 = { class: "flex justify-between items-center" };
const _hoisted_4 = { class: "font-semibold" };
const _hoisted_5 = ["aria-label", "title"];
const _hoisted_6 = { class: "my-1 text-muted collapsible-content" };
const _hoisted_7 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-4 px-3 lg:px-4 pb-3 lg:pb-4" };
const _hoisted_8 = { class: "font-normal text-2xl" };
const _hoisted_9 = ["textContent"];
const _hoisted_10 = { class: "text-muted text-sm" };
const _hoisted_11 = ["textContent"];
const _hoisted_12 = ["textContent"];
const _hoisted_13 = ["textContent"];
const _hoisted_14 = { class: "text-muted text-sm" };
const _hoisted_15 = ["textContent"];
const _hoisted_16 = ["textContent"];
const _hoisted_17 = ["textContent"];
const _hoisted_18 = { class: "text-muted text-sm" };
const _hoisted_19 = ["textContent"];
const _hoisted_20 = ["textContent"];
const _hoisted_21 = { key: 0 };
const _hoisted_22 = ["textContent"];
const _hoisted_23 = { class: "text-muted text-sm" };
const _hoisted_24 = ["textContent"];
const _hoisted_25 = ["textContent"];
import { ref, computed } from 'vue';
import { ___, toFixedNumberStrWithFallback } from '@ts/common/language';
import SvgVue from '@ts/components/utils/SvgVue.vue';
import {} from '@ts/common/datasets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CompareAnthropometry',
    props: {
        dataA: { default: undefined },
        dataB: { default: undefined },
        help: { type: Boolean, default: false },
        header: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const showHelp = ref(false);
        const height = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined ? undefined : -100.0 * (1.0 - props.dataA.height / props.dataB.height);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.height, 0),
                stringB: toFixedNumberStrWithFallback(props.dataB?.height, 0),
                // class: value && value > 0 ? 'text-green' : value && value < 0 ? 'text-red' : '',
            };
        });
        const weight = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined ? undefined : -100.0 * (1.0 - props.dataA.weight / props.dataB.weight);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.weight, 1),
                stringB: toFixedNumberStrWithFallback(props.dataB?.weight, 1),
                class: value && value < 0 ? 'text-emerald-500' : value && value < 0 ? 'text-red-500' : '',
            };
        });
        const bmi = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined ? undefined : -100.0 * (1.0 - props.dataA.bmi / props.dataB.bmi);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.bmi, 1),
                stringB: toFixedNumberStrWithFallback(props.dataB?.bmi, 1),
                class: value && value < 0 ? 'text-emerald-500' : value && value < 0 ? 'text-red-500' : '',
            };
        });
        const bodyfat = computed(() => {
            const value = props.dataA === undefined || props.dataB === undefined || props.dataA.bodyfat === null || props.dataB.bodyfat === null ? undefined : -100.0 * (1.0 - props.dataA.bodyfat / props.dataB.bodyfat);
            return {
                value: value,
                string: toFixedNumberStrWithFallback(value, 1),
                stringA: toFixedNumberStrWithFallback(props.dataA?.bodyfat, 1),
                stringB: toFixedNumberStrWithFallback(props.dataB?.bodyfat, 1),
                class: value && value > 0 ? 'text-emerald-500' : value && value < 0 ? 'text-red-500' : '',
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.header)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(___)({ en: 'Anthropometry', de: 'Anthropometrie' })), 1 /* TEXT */),
                                (__props.help)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (showHelp.value = !showHelp.value)),
                                        type: "button",
                                        class: "btn text-gray-350 dark:text-gray-450 hover:text-primary-500",
                                        "aria-label": _unref(___)({ en: 'Toggle help', de: 'Hilfe ein- und ausblenden' }),
                                        title: _unref(___)({ en: 'Help', de: 'Hilfe' })
                                    }, [
                                        _cache[0] || (_setBlockTracking(-1, true),
                                            (_cache[0] = _createVNode(SvgVue, {
                                                class: "w-4 h-4",
                                                icon: "lucide/circle-question-mark"
                                            })).cacheIndex = 0,
                                            _setBlockTracking(1),
                                            _cache[0])
                                    ], 8 /* PROPS */, _hoisted_5))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            (__props.help)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["collapsible", showHelp.value ? 'expanded' : ''])
                                }, [
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(___)({
                                        en: 'The science of the measurements and proportions of the human body is called anthropometry.',
                                        de: 'Die Lehre von den Maßen und Maßverhältnissen des menschlichen Körpers wird als Anthropometrie bezeichnet.',
                                    })), 1 /* TEXT */)
                                ], 2 /* CLASS */))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(_unref(___)({ en: 'Height', de: 'Größe' })), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(height.value.string)
                                }, null, 8 /* PROPS */, _hoisted_9),
                                _cache[2] || (_cache[2] = _createTextVNode(" %", -1 /* CACHED */))
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(height.value.stringA)
                                }, null, 8 /* PROPS */, _hoisted_11),
                                _cache[3] || (_cache[3] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(height.value.stringB)
                                }, null, 8 /* PROPS */, _hoisted_12),
                                _cache[4] || (_cache[4] = _createTextVNode(" cm", -1 /* CACHED */))
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(_unref(___)({ en: 'Weight', de: 'Gewicht' })), 1 /* TEXT */),
                            _createElementVNode("div", {
                                class: _normalizeClass(["font-normal text-2xl", weight.value.class])
                            }, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(weight.value.string)
                                }, null, 8 /* PROPS */, _hoisted_13),
                                _cache[5] || (_cache[5] = _createTextVNode(" %", -1 /* CACHED */))
                            ], 2 /* CLASS */),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(weight.value.stringA)
                                }, null, 8 /* PROPS */, _hoisted_15),
                                _cache[6] || (_cache[6] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(weight.value.stringB)
                                }, null, 8 /* PROPS */, _hoisted_16),
                                _cache[7] || (_cache[7] = _createTextVNode(" kg", -1 /* CACHED */))
                            ])
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", null, _toDisplayString(_unref(___)({ en: 'Body Mass Index', de: 'Body Mass Index' })), 1 /* TEXT */),
                            _createElementVNode("div", {
                                class: _normalizeClass(["font-normal text-2xl", bmi.value.class])
                            }, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(bmi.value.string)
                                }, null, 8 /* PROPS */, _hoisted_17),
                                _cache[8] || (_cache[8] = _createTextVNode(" %", -1 /* CACHED */))
                            ], 2 /* CLASS */),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(bmi.value.stringA)
                                }, null, 8 /* PROPS */, _hoisted_19),
                                _cache[9] || (_cache[9] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                _createElementVNode("span", {
                                    textContent: _toDisplayString(bmi.value.stringB)
                                }, null, 8 /* PROPS */, _hoisted_20)
                            ])
                        ]),
                        (props.dataA !== undefined && props.dataB !== undefined && props.dataA?.bodyfat !== null && props.dataB?.bodyfat !== null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", null, _toDisplayString(_unref(___)({ en: 'Body Fat', de: 'Körperfettanteil' })), 1 /* TEXT */),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["font-normal text-2xl", bmi.value.class])
                                }, [
                                    _createElementVNode("span", {
                                        textContent: _toDisplayString(bmi.value.string)
                                    }, null, 8 /* PROPS */, _hoisted_22),
                                    _cache[10] || (_cache[10] = _createTextVNode(" %", -1 /* CACHED */))
                                ], 2 /* CLASS */),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("span", {
                                        textContent: _toDisplayString(bmi.value.stringA)
                                    }, null, 8 /* PROPS */, _hoisted_24),
                                    _cache[11] || (_cache[11] = _createTextVNode(" vs. ", -1 /* CACHED */)),
                                    _createElementVNode("span", {
                                        textContent: _toDisplayString(bmi.value.stringB)
                                    }, null, 8 /* PROPS */, _hoisted_25),
                                    _cache[12] || (_cache[12] = _createTextVNode(" %", -1 /* CACHED */))
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ]));
        };
    }
});
